/* globals angular, _ */
(function () {
  "use strict";

  function EditSaleFormCtrl($scope, $mdSidenav, $mdToast, Pedido, moment) {
    var ctrl = this;
    ctrl.postDate = "--";
    ctrl.deliveryDate = "--";
    ctrl.states = (
      "AC AL AP AM BA CE DF ES GO MA MT MS MG" +
      " PA PB PR PE PI RJ RN RS RO RR SC SP SE TO"
    ).split(" ");
    function getDeliveryOptions(cep) {
      return Pedido.obterOpcoes(cep)
        .then(function (deliveryOptions) {
          ctrl.sale.deliveryOptions = deliveryOptions.opcoes;
        })
        .catch(function (err) {
          console.log(err.statusText);
        });
    }
    function getDeliveryObject(deliveryCod) {
      return _.find(ctrl.sale.deliveryOptions, function (obj) {
        return obj.codigo === deliveryCod;
      });
    }
    function getDeliveryDates(deliveryCod) {
      var deliveryObj = getDeliveryObject(deliveryCod);
      if (!deliveryObj) {
        return;
      }
      ctrl.postDate = moment(deliveryObj.dataPostagem).format("ddd, DD MMM");
      ctrl.deliveryDate = deliveryObj.dataChegada
        ? moment(deliveryObj.dataChegada).format("ddd, DD MMM")
        : "Não disponível";
      ctrl.sale.formaEnvio.nomeExibicao = deliveryObj.nomeExibicao;
    }
    function getInsuranceValues(deliveryCod) {
      var deliveryObj = getDeliveryObject(deliveryCod);
      if (!deliveryObj) {
        return;
      }
      ctrl.maxValue = deliveryObj.valorDeclaradoMaximo;
      ctrl.minValue = deliveryObj.valorDeclaradoMinimo;
    }
    function isFormVisible() {
      return $mdSidenav("right").isOpen();
    }

    ctrl.$onChanges = function (model) {
      if (!model.sale.currentValue) {
        return;
      }
      var sale = model.sale.currentValue;
      ctrl.sale.isChecked = sale.tipoDocumentoOrigem ? true : false;
      ctrl.sale.destinatario.cpfcnpj = ctrl.sale.destinatario.cpf
        ? ctrl.sale.destinatario.cpf
        : ctrl.sale.destinatario.cnpj;
      ctrl.sale.destinatario.endereco.cep = sale.destinatario.endereco.cep.replace(
        /-/,
        ""
      );
      ctrl.sale.quantidadeVolumes = sale.quantidadeVolumes;
      getDeliveryOptions(ctrl.sale.destinatario.endereco.cep).then(function () {
        if (ctrl.sale.formaEnvio) {
          var cod = ctrl.sale.formaEnvio.codigo;
          getDeliveryDates(cod);
          getInsuranceValues(cod);
        }
      });
    };
    ctrl.closeSidenav = function () {
      $mdSidenav("right")
        .close()
        .then(function () {
          ctrl.isOpen = false;
        });
    };
    ctrl.onOrderOptsChange = function () {
      var cod = ctrl.sale.formaEnvio.codigo;
      getDeliveryDates(cod);
      getInsuranceValues(cod);
    };
    ctrl.onDocumentChange = function () {
      ctrl.sale.tipoDocumentoOrigem = ctrl.sale.isChecked ? "NFe" : "";
    };
    $scope.$on("validation:success", function () {
      if (!isFormVisible()) {
        return;
      }
      ctrl.isSubmitingForm = false;
      $mdSidenav("right")
        .close()
        .then(function () {
          ctrl.isOpen = false;
        });
    });
    $scope.$on("validation:fail", function (evt, sale) {
      if (!isFormVisible()) {
        return;
      }
      ctrl.sale = sale;
      ctrl.isSubmitingForm = false;
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("Verifique os erros e tente novamente")
          .position("top right")
      );
    });
    // Listen for backdrop click
    $scope.$watch(
      function () {
        return $mdSidenav("right").isOpen();
      },
      function (newValue) {
        if (!newValue) {
          ctrl.isOpen = false;
        }
      }
    );
    ctrl.submitForm = function (form) {
      ctrl.isSubmitingForm = true;
      if (form.cpfcnpj.$modelValue) {
        ctrl.sale.destinatario.cpf =
          form.cpfcnpj.$modelValue.length === 11
            ? form.cpfcnpj.$modelValue
            : "";
        ctrl.sale.destinatario.cnpj =
          form.cpfcnpj.$modelValue.length === 14
            ? form.cpfcnpj.$modelValue
            : "";
      }
      ctrl.onSubmit({
        $event: {
          sale: ctrl.sale,
        },
      });
    };
  }

  angular.module("mandaeApp").controller("EditSaleFormCtrl", EditSaleFormCtrl);
})();
